import React from 'react';
import ServiceTemplate from '../components/ServiceTemplate';

const ImportSolutions = () => {
  return (
    <ServiceTemplate
      title="Import Solutions"
      subtitle="Importing to South Africa"
      description="Complete import coordination including freight booking, customs clearance, and delivery to your South African destination."
      whatIsIt="Import solutions cover the complete process of bringing goods into South Africa from Europe and Africa. This includes freight coordination (air or ocean), customs clearance at South African ports, and delivery to your final destination. NETEXEC GLOBAL manages the entire import process on your behalf."
      whoFor="This service is for South African businesses importing commercial cargo, products, raw materials, or equipment from Europe and Africa. It's ideal for businesses that need a single partner to coordinate the entire import process."
      whenToUse="Use import solutions whenever you're bringing goods into South Africa from international suppliers. Whether it's regular inventory imports or one-off equipment purchases, end-to-end import coordination ensures smooth processing and delivery."
      howWeHelp="NETEXEC GLOBAL coordinates your imports from origin to South African destination. We arrange freight (air or ocean), prepare import documentation, handle customs clearance in South Africa, coordinate port processing, and arrange onward delivery."
      benefits={[
        'Single point of contact for complete import process',
        'Freight coordination (air or ocean) from Europe and Africa',
        'Expert South African customs clearance',
        'Compliance with import regulations and permits',
        'Delivery coordination to your South African location'
      ]}
      nextSteps="Provide NETEXEC GLOBAL with your supplier details, cargo information, and delivery destination in South Africa. We'll handle the complete import coordination with transparent pricing and clear timelines."
      image="https://images.unsplash.com/photo-1761195696590-3490ea770aa1?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85"
    />
  );
};

export default ImportSolutions;